var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4374 1.97928C28.1574 5.87928 28.1074 12.6693 22.9874 16.2293C21.9174 16.9693 22.9374 18.7393 24.0174 17.9893C30.1074 13.7493 30.6874 5.3293 24.8774 0.539297C23.8674 -0.290703 22.4174 1.14928 23.4374 1.97928Z",
    fill: "#D5EFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06748 0.239262C-1.75252 5.01926 -1.19252 13.4393 4.88748 17.6993C5.96748 18.4493 6.98748 16.6893 5.91748 15.9393C0.807481 12.3693 0.787481 5.55926 5.50748 1.68926C6.52748 0.859259 5.06748 -0.580744 4.06748 0.249256V0.239262Z",
    fill: "#D5EFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7575 5.02933C21.3875 7.19933 21.4575 10.9793 18.5675 12.9893C17.4975 13.7293 18.5175 15.4993 19.5975 14.7493C23.4675 12.0593 23.9175 6.65933 20.1975 3.57933C19.1875 2.74933 17.7375 4.18934 18.7575 5.01934V5.02933Z",
    fill: "#D5EFF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74737 3.23926C5.01737 6.29926 5.45737 11.7093 9.32737 14.4093C10.4074 15.1593 11.4274 13.3993 10.3574 12.6493C7.47737 10.6293 7.56737 6.84926 10.1874 4.68926C11.2074 3.85926 9.74737 2.41926 8.74737 3.24926V3.23926Z",
    fill: "#D5EFF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5476 9.95895C15.249 9.95895 15.8176 9.39035 15.8176 8.68895C15.8176 7.98755 15.249 7.41895 14.5476 7.41895C13.8462 7.41895 13.2776 7.98755 13.2776 8.68895C13.2776 9.39035 13.8462 9.95895 14.5476 9.95895Z",
    fill: "#D5EFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolive);
export default __webpack_public_path__ + "static/media/golive.97638cd12fb22cb6da28a6191aca221e.svg";
export { ForwardRef as ReactComponent };